'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _findIndex2 = require('lodash/findIndex');

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _invertBy3 = require('lodash/invertBy');

var _invertBy4 = _interopRequireDefault(_invertBy3);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _utils = require('helpers/utils');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./SharespaceLists.scss');

var SharespacePressList = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(SharespacePressList, _Component);

  function SharespacePressList() {
    var _ref;

    (0, _classCallCheck3.default)(this, SharespacePressList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SharespacePressList.__proto__ || (0, _getPrototypeOf2.default)(SharespacePressList)).call.apply(_ref, [this].concat(args)));

    _this.state = { checkedItems: {} };
    return _this;
  }

  (0, _createClass3.default)(SharespacePressList, [{
    key: 'onSelectAllClick',
    value: function onSelectAllClick() {
      var isAllItemsSelected = this.state.isAllItemsSelected;

      if (isAllItemsSelected) {
        this.selectNone();
      } else {
        this.selectAll();
      }
    }
  }, {
    key: 'onSelect',
    value: function onSelect() {
      var checkedItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props = this.props,
          onSelect = _props.onSelect,
          pressList = _props.pressList;

      var checkedArray = this.getCheckedItemsArray(checkedItems);
      var result = [];
      checkedArray.map(function (pressId) {
        var index = (0, _findIndex3.default)(pressList, { pressId: Number(pressId) }) + 1;
        result.push(index);
      });
      onSelect(result);
    }
  }, {
    key: 'getCheckedItemsArray',
    value: function getCheckedItemsArray(checkedItems) {
      return (0, _invertBy4.default)(checkedItems || this.state.checkedItems || {}).true || [];
    }
  }, {
    key: 'toggleItemChecked',
    value: function toggleItemChecked(id) {
      var pressList = this.props.pressList;


      var checkedItems = (0, _extends4.default)({}, this.state.checkedItems, (0, _defineProperty3.default)({}, id, !this.state.checkedItems[id]));
      var checkedItemsArr = this.getCheckedItemsArray(checkedItems);
      this.setState({ checkedItems: checkedItems, isAllItemsSelected: checkedItemsArr.length === pressList.length });
      this.onSelect(checkedItems);
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      var pressList = this.props.pressList;

      var checkedItems = {};
      pressList.map(function (item) {
        return checkedItems[item.pressId] = true;
      });
      this.setState({ checkedItems: checkedItems, isAllItemsSelected: true });
      this.onSelect(checkedItems);
    }
  }, {
    key: 'selectNone',
    value: function selectNone() {
      this.setState({ checkedItems: {}, isAllItemsSelected: false });
      this.onSelect({});
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          t = _props2.t,
          pressList = _props2.pressList,
          loading = _props2.loading,
          project = _props2.project;
      var _state = this.state,
          checkedItems = _state.checkedItems,
          isAllItemsSelected = _state.isAllItemsSelected;

      var isLocked = !!project.isLocked;

      if (!project.id) {
        return null;
      }

      if (isLocked) {
        return _react2.default.createElement(
          'div',
          { className: 'bold' },
          t('Press will be automatically transferred to your new project.')
        );
      }

      if (!pressList.length && !loading) {
        return _react2.default.createElement(
          'div',
          null,
          t('Press list is empty')
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'overflow-hidden margin-bottom-10' },
          _react2.default.createElement(
            'div',
            { className: 'hint pull-left' },
            t('Select press you want to reuse in your project.')
          ),
          _react2.default.createElement(
            'div',
            { className: styles.selectAllContainer },
            _react2.default.createElement(_components.Checkbox, {
              className: 'padding-5 inline',
              checked: isAllItemsSelected,
              textBefore: t('Select all'),
              onChange: this.onSelectAllClick
            })
          )
        ),
        _react2.default.createElement(
          _components.List,
          null,
          pressList.map(function (item) {
            return _react2.default.createElement(
              _components.ListItem,
              { fullWidth: true, key: item.pressId, onClick: function onClick() {
                  return _this2.toggleItemChecked(item.pressId);
                } },
              _react2.default.createElement(
                'div',
                null,
                item.fileName
              ),
              _react2.default.createElement(
                'div',
                { className: styles.checkboxCell },
                _react2.default.createElement(_components.Checkbox, {
                  className: 'padding-5 inline',
                  checked: checkedItems[item.pressId],
                  onClick: _utils.stopEvent
                })
              )
            );
          })
        ),
        loading && _react2.default.createElement(_components.Loader, null)
      );
    }
  }]);
  return SharespacePressList;
}(_react.Component), _class3.propTypes = {
  loading: _propTypes2.default.bool,
  onSelect: _propTypes2.default.func,
  pressList: _propTypes2.default.array,
  project: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  onSelect: _noop3.default,
  pressList: [],
  project: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSelectAllClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelectAllClick'), _class2.prototype)), _class2)) || _class);
exports.default = SharespacePressList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectCreate/components/SharespacePressList.js
// module id = 2192
// module chunks = 1